import React, { forwardRef } from 'react'
import cx from 'classnames'

const PageTitle = forwardRef(({
  className,
  ...props
}, ref) => {
  const classes = cx(className, 'm-page-title')

  return (
    <h1
      className={classes}
      ref={ref}
      {...props}
      tabIndex="-1"
    />
  )
})

export default PageTitle
